<script lang="ts">
    import QuestionsIcon from "@apps/reviews/components/icons/QuestionsIcon.svelte";
    import { createEventDispatcher } from "svelte";

    import BaseButton from "@components/Buttons/BaseButton.svelte";
    import Icon from "@components/Icon.svelte";
    import T from "@components/T.svelte";

    export let questionsCount: number;

    const dispatch = createEventDispatcher();
</script>

<BaseButton
    variant="link"
    size="large"
    ariaLabel="Ask a question"
    class="gw-rv-average__btn"
    on:click={() => dispatch("goToQuestions")}
>
    <Icon width="20" height="20">
        <QuestionsIcon />
    </Icon>
    <span class="gw-rv-average__btn-text">
        {#if questionsCount === 1}
            1 <T
                namespace="reviews.AverageReviewsWidget"
                translationKey="question"
            />
        {:else if questionsCount}
            <T
                namespace="reviews.AverageReviewsWidget"
                translationKey="questions"
                translationOptions={{
                    count: questionsCount,
                }}
            />
        {:else}
            <T
                namespace="reviews.critical.AverageReviewsWidget"
                translationKey="ask_a_question"
            />
        {/if}
    </span>
</BaseButton>

<style>
    :global(.gw-btn.gw-rv-average__btn) {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 0.5rem;
        color: inherit;
        font-weight: inherit;
        font-family: inherit;
        font-size: inherit;
        text-indent: 0;
        flex-wrap: wrap;
    }

    .gw-rv-average__btn-text {
        font-size: 0.875em;
        line-height: 1.2em;
        text-decoration: underline;
        white-space: nowrap;
    }
</style>
